export function successCallback(event, collectionName, cb) {
  console.log("Document written to: ", collectionName);
  if (cb) {
    cb();
  }
  return null;
}
